import { Button, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AiAssistantLoadingIcon } from '@/components/common/AiAssistantLoadingIcon';
import DataLoadError from '@/components/errors/DataLoadError';
import { useProject } from '../context/ProjectContext';

export function NoProject({ children }: { children: React.ReactNode }) {
  const {
    projectId,
    project,
    projectsLoaded,
    projectsLoadFailed,
    projectsRetrying,
    reloadProjects,
    loadFailed,
    refresh,
    loading,
    openProjectSetup,
  } = useProject();

  if (!projectsLoaded) return null;

  if (projectsLoadFailed) {
    return (
      <DataLoadError
        onRetry={() => void reloadProjects()}
        isRetrying={projectsRetrying}
      />
    );
  }

  const hasValidProject = Boolean(projectId && project);
  if (!hasValidProject) {
    return (
      <div className="w-100">
        <Card className="border border-dashed shadow-none overflow-hidden w-100">
          <Card.Body className="py-5 px-4 text-center">
            <AiAssistantLoadingIcon className="mx-auto mb-4" />

            <h2 className="fs-1 fw-bold text-1000 mb-3">ردیاب AI</h2>
            <p className="fs-0 text-500 mx-auto mb-4 lh-base" style={{ maxWidth: '32rem' }}>
              میزان دیده‌شدن برندتان را در پاسخ‌های ChatGPT و سایر مدل‌های هوش مصنوعی ردیابی
              کنید. برای شروع، پروژه خود را راه‌اندازی کنید.
            </p>

            <Button variant="primary" className="px-4" onClick={openProjectSetup}>
              <FontAwesomeIcon icon="play" className="me-2" />
              شروع راه‌اندازی
            </Button>
          </Card.Body>
        </Card>
      </div>
    );
  }

  if (loadFailed) {
    return (
      <DataLoadError
        onRetry={() => void refresh()}
        isRetrying={loading}
      />
    );
  }

  return <>{children}</>;
}
